import axios from "axios";
import { responseHandler } from "../utils/responseHandler";
import LazadaKeyValidation from "../utils/LazadaKeyValidation";

// const API_BASE_URL = "https://warehouse.innoventixsolutions.in/api/"; // Your API URL
const API_BASE_URL = "https://admin.beawms.com/api/"; // Your API URL

// Create Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// export const adminLogin1 = async () => {
//   try {
//     const response = await api.get("admin/login");
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching:", error);
//     throw error;
//   }
// };

export const sampleData = async () => {
  try {
    let response = {};
    response.status = 401;
    return await responseHandler(response);
  } catch (error) {
    console.error("Error Login:", error);
    throw error;
  }
};

// Authentication API's Start ************************************************************************************************************
export const logisticsLogin = async (postData) => {
  try {
    const response = await api.post("logistics/login", postData);
    return response.data;
  } catch (error) {
    console.error("Error Login:", error);
    throw error;
  }
};

export const logisticsForgotPass = async (postData) => {
  try {
    const response = await api.post("logistics/forgot-password", postData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logisticsOtpVerify = async (postData) => {
  try {
    const response = await api.post("logistics/verify-otp", postData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logisticsNewPass = async (postData) => {
  try {
    const response = await api.post("logistics/reset-password", postData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Authentication API's End ************************************************************************************************************

// Lazada API's Start ************************************************************************************************************
export const getCategories = async (searchTerm = '') => {
  try {
    // Only add search parameter if searchTerm is provided
    const url = searchTerm ?
      `lazada/get-category-suggestion?product_name=${encodeURIComponent(searchTerm)}` :
      "lazada/get-category-suggestion";

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching categories", error);
    throw error;
  }
};

export const getAttributes = async (categoryId) => {
  try {
    const response = await api.get(`lazada/get-category-attributes`, {
      params: {
        primary_category_id: categoryId,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching attributes", error);
    throw error;
  }
};

export const getBrands = async (params = {}, signal) => {
  try {
    const response = await api.get("lazada/get-brands", {
      params,
      signal,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadImages = async (formData) => {
  try {
    const response = await api.post("lazada/upload-image", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
};

export const createLazadaProduct = async (formData) => {
  try {
    const response = await api.post("lazada/product-create", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
};

export const lazadaProductStatusUpdate = async (data) => {
  try {
    const response = await api.post("admin/update-status", data);
    return response.data;
  } catch (error) {
    console.error("Error updating product:", error);
    throw error;
  }
};
// Lazada API's End ************************************************************************************************************

// Product API's Start ************************************************************************************************************
export const productList = async (params) => {
  try {
    const response = await api.get("logistics/list-all-products", {
      params: {
        ...params,
        sort: "id",
        sort_order: "desc",
      }
    });
    return response.data;
  } catch (error) {
    const abc = LazadaKeyValidation({ "message": error.response.data.message, "status": error.response.data.status });
    throw error;
  }
};

export const createProduct = async (formData) => {
  try {
    const response = await api.post("logistics/create-product", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
};

export const updateProduct = async (formData) => {
  try {
    const response = await api.post(`logistics/update-product`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

    return response.data;
  } catch (error) {
    console.error("Error updating product:", error);
    throw error;
  }
};

// export const updateProduct = async (formData) => {
//   try {
//     const response = await axios.post('/api/update-product', formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const getProductDetailsById = async (productId) => {
  try {
    const response = await api.get(`logistics/get-product-by-id/${productId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const productTransaction = async (transaction_id) => {
  try {
    const response = await api.get(`logistics/list-products/${transaction_id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const updateProductQuantity = async (data) => {
  try {
    const response = await api.post("logistics/update-products-quantity", data);
    return response.data;
  } catch (error) {
    console.error("Error updating product quantity:", error);
    throw error;
  }
};

export const getProductByBarcodeNumber = async (barcode) => {
  try {
    const response = await api.get(`logistics/get-product-by-barcode/${barcode}`);
    return response.data;
  }
  catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const productsOutbound = async () => {
  try {
    const response = await api.post("logistics/outbound-product");
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};
// Product API's End ************************************************************************************************************

// ProductTransaction API's Start ************************************************************************************************************
export const pastTransaction = async (params) => {
  try {
    const response = await api.get("logistics/list-transaction-history", {
      params: {
        ...params,
        user_type: 'logistic',
        sort: "id",
        sort_order: "desc"
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const productTransactionHistoryList = async (params) => {
  try {
    const response = await api.get("logistics/list-transaction-history", {
      params: {
        ...params,
        user_type: 'logistic',
        sort: 'id',
        sort_order: 'desc'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
// ProductTransaction API's End ************************************************************************************************************

// Inventory API's Start ************************************************************************************************************
export const inventoryList = async (params, logisticsId) => {
  try {
    const response = await api.get(`logistics/list-products/${logisticsId}`, {
      params: {
        ...params,
        sort: "id",
        sort_order: "desc",
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Inventory API's End ************************************************************************************************************

// Logistic API's Start ************************************************************************************************************
export const logisticList = async (params) => {
  try {
    const response = await api.get("admin/list-logistics", {
      params: {
        ...params,
        sort: 'id',
        sort_order: 'desc',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const createLogistic = async (data) => {
  try {
    const response = await api.post("admin/create-logistics", data);
    return response;
  } catch (error) {
    console.error("Error creating logistic:", error);
    throw error;
  }
};


export const getLogisticById = async (id) => {
  try {
    const response = await api.get(`admin/get-logistics/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateLogistic = async (data) => {
  try {
    const response = await api.post(`admin/update-logistics`, data);
    return response;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};
// Logistic API's End ************************************************************************************************************

// Warehouse API's Start ************************************************************************************************************
export const warehouseList = async (params) => {
  try {
    const response = await api.get("logistics/list-warehouse", {
      params: {
        ...params,
        sort_by: 'id',
        sort_order: 'desc'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const createWarehouse = async (data) => {
  try {
    const response = await api.post("admin/create-warehouse", data);
    return response.data;
  } catch (error) {
    console.error("Error creating warehouse:", error);
    throw error;
  }
};

export const getWarehouseById = async (id) => {
  try {
    const response = await api.get(`admin/warehouse/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateWarehouse = async (data) => {
  try {
    const response = await api.post("admin/update-warehouse", data);
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};
// Warehouse API's End ************************************************************************************************************

// Location API's ************************************************************************************************************
export const getCountries = async () => {
  try {
    const response = await api.get('option/list-country');
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStates = async (countryId) => {
  try {
    // const response = await api.get(`option/list-state/${countryId}`);
    const response = await api.get(`option/list-state`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCities = async (stateId) => {
  try {
    // const response = await api.get(`option/list-city/${stateId}`);
    const response = await api.get(`option/list-city`);
    return response;
  } catch (error) {
    throw error;
  }
};
// Location API's End ************************************************************************************************************

// Company API's Start ************************************************************************************************************
// export const companyList = async (params) => {
//   try {
//     const response = await api.get("admin/list-company", { 
//       params: {
//         sort: 'id',
//         sort_order: 'desc',
//         company_name: params.company_name || '',
//         from_date: params.from_date || '',
//         to_date: params.to_date || '',
//         status: params.status || '',
//         page: params.page || '1',
//         limit: params.limit || '10'
//     }
//   });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching:", error);
//     throw error;
//   }
// };

export const companyList = async (params) => {
  try {
    // Prepare parameters conditionally
    const response = await api.get("admin/list-company", {
      params: {
        sort: 'id',
        sort_order: 'desc',
        ...(params.page && { page: params.page }),
        ...(params.paginate_per_page && { paginate_per_page: params.paginate_per_page }),
        ...(params.from && { from: params.from }),
        ...(params.to && { to: params.to }),
        ...(params.status && { status: params.status }),
        ...(params.company_name && { company_name: params.company_name }),
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const allCompanyList = async (params) => {
  try {
    const response = await api.get("logistics/list-all-company", {
      params: {
        sort: 'id',
        sort_order: 'desc',
        company_name: params.company_name || '',
        from_date: params.from_date || '',
        to_date: params.to_date || '',
        status: params.status || '',
        page: params.page || '1',
        limit: params.limit || '10'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching:", error);
    throw error;
  }
};

export const createCompany = async (data) => {
  try {
    const response = await api.post("admin/create-company", data);
    return response.data;
  } catch (error) {
    console.error("Error creating company:", error);
    throw error;
  }
};

export const getCompanyById = async (id) => {
  try {
    const response = await api.get(`admin/company/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompany = async (data) => {
  try {
    const response = await api.post(`admin/update-company`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating company:", error);
    throw error;
  }
};

// Company-Warehouse API's
export const createCompanyWarehouse = async (data) => {
  try {
    const response = await api.post("admin/create-company-warehouse", data);
    return response.data;
  } catch (error) {
    console.error("Error creating company warehouse:", error);
    throw error;
  }
};

export const getCompanyWarehouseById = async (id) => {
  try {
    const response = await api.get(`admin/list-company-warehouse/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyWarehouse = async (data) => {
  try {
    const response = await api.post(`admin/update-company-warehouse`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating company warehouse:", error);
    throw error;
  }
};

export const getCompanyReport = async (data) => {
  try {
    const response = await api.get(`admin/company-report`, data);
    return response.data;
  } catch (error) {
    console.error("Error getting company report:", error);
    throw error;
  }
};
// Company API's End ************************************************************************************************************